<template>
  <div :class="['filter-container flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <ms-validate ref="validateObserver">
          <menu-wrapper>
            <template #menu-button="{toggleMenu}">
              <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
                <div :class="['icon20', nativeFilterIconClass]" :title="tooltipIcon"></div>
              </button>
            </template>
            <template #menu-content>
              <template v-for="(item, i) in filterOperators" :key="i">
                <menu-item
                  class="filter-operator-item"
                  :class="item.enumValue === operatorValue ? 'active' : ''"
                  @menu-item-click="filterOperatorItemClick(item)"
                  :icon="['icon24', item.icon]"
                  >{{ item?.enumText }}</menu-item
                >
              </template>
            </template>
          </menu-wrapper>
        </ms-validate>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-combobox-enum
        v-model="filterValue"
        ref="thEnum"
        :enum="col.enum"
        class="ms-input-filter-value"
        :title="col.tooltip || col.title || col.definition || col.caption"
        :isShowText="false"
        :values="col.filterValue"
        :sortEnum="col.sortEnum"
        :forceReload="col.forceReload"
        :queryMode="col.queryMode ?? 'local'"
        :hasValidateControl="col.hasValidateControl"
        :customData="propsData.customFilterData"
        :forceSelection="false"
        @selected="
          ({newData}) => {
            customFilterHeaderHandleEnum(newData, {
              operator: operatorValue,
              value: filterValue,
            });
          }
        "
        @comboboxLoadData="
          payload => {
            searchData({operator: operatorValue, value: thEnum.internalText});
            onComboboxLoadData(payload, true, {
              dataField: col.dataField,
              isEnum: true,
              enum: col.enum,
              valueText: thEnum.internalText,
            });
          }
        "
        @comboboxLoadDataLocal="
          payload => {
            searchData({operator: operatorValue, value: thEnum.internalText});
            onComboboxLoadData(payload, true, {
              dataField: col.dataField,
              isEnum: true,
              enum: col.enum,
              valueText: thEnum.internalText,
            });
          }
        "
        @keydown.stop=""
        :hasBorder="false"
        @handleScrollEndLocal="handleScrollEndLocal"
        @beforeExpandClick="beforeExpandClick"
        @onHandleInputText="onHandleInputText"
      ></ms-combobox-enum>
    </div>
  </div>
</template>
<script>
import {defineComponent, getCurrentInstance} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import msValidate from '@/components/validate/MsValidate.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
export default defineComponent({
  extends: msThOptionBase,
  components: {msValidate, MenuItem, MenuWrapper},
  name: 'MsThOptionEnum',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
    propsData: {
      default: {},
      type: Object,
    },
    dbOptionHeight: {
      type: String,
    },
  },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();

    //Khai báo data variable
    const {
      nativeFilterIconClass,
      tooltipIcon,
      operatorValue,
      filterValue,
      filterOperators,
      filterHeaderHandleEnum,
      filterOperatorItemClick,
      removeFilter,
      thEnum,
    } = setup(props, {
      emit,
    });
    //Method
    /**
     * Xóa Timeout
     * lttuan1
     */
    const customFilterHeaderHandleEnum = (newData, {operator: operatorValue, value: filterValue}) => {
      clearTimeout(proxy.timeOut);
      filterHeaderHandleEnum(newData, {operator: operatorValue, value: filterValue})
    }
    /**
     * Search dữ liệu khi nhập sau 1s
     * dqvinh 9.5.2023
     */
    const searchData = ({operator: operatorValue, value: filterValue}) => {
      clearTimeout(proxy.timeOut);
      proxy.timeOut = setTimeout(() => {
        proxy.filterValue = filterValue;
        if (!filterValue?.trim()?.length > 0) {
          filterValue = '';
        } else {
          filterHeaderHandleEnum(
            {enumText: filterValue},
            {operator: operatorValue, value: filterValue, isFreeText: true},
          );
        }
      }, 500);
    };

    const onComboboxLoadData = (payload, row, dataField) => {
      if (payload?.filter) {
        let fil = JSON.parse(payload.filter);
        if (fil?.length > 0) {
          let listItemEnumText = [];
          let listItemEnum = proxy.$ms.constant[proxy.col.enum];
          for (let [key, val] of Object.entries(listItemEnum)) {
            listItemEnumText.push({
              enum: key,
              enumValue: val,
              enumText: i18n.t('i18nEnum.' + proxy.col.enum + '.' + key),
            });
          }
          // Lấy ra các enum có text chứa value truyền vào
          let filerEnum = listItemEnumText.filter(x =>
            x.enumText.toLocaleLowerCase().includes(dataField.valueText.toLocaleLowerCase()),
          );

          fil[0].Value = filerEnum.map(x => x.enumValue);
          fil[0].Operator = proxy.$ms.constant.FilterOperator.In;
          payload.filter = JSON.stringify(fil);
        }
      }
      emit('load-filter-header', payload, row, dataField);
    };

    /**
     * Bắn sự kiện scroll local
     */
    const handleScrollEndLocal = () => {
      emit('scroll-end-combobox-local');
    }
    /**
     * Bắn sự kiện xổ combo
     */
    const beforeExpandClick = () => {
      emit('before-expand-click');
    }
    /**
     * Bắn sự kiện input combo
     */
    const onHandleInputText = (value) => {
      emit('handle-input-text', value);
    }

    //Hooks
    return {
      nativeFilterIconClass,
      tooltipIcon,
      filterValue,
      operatorValue,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandleEnum,
      removeFilter,
      thEnum,
      searchData,
      onComboboxLoadData,
      customFilterHeaderHandleEnum,
      handleScrollEndLocal,
      beforeExpandClick,
      onHandleInputText,
    };
  },
});
</script>
